import React from 'react';
import Layout from './src/components/Layout';

// Авто-перезагрузка при протухших JS-чанках после нового деплоя
// (старая открытая вкладка: кнопки/меню «не реагируют», пока не обновишь F5).
// Один раз за сессию навигации, чтобы не зациклиться.
const isChunkError = (msg = '') =>
  /Loading chunk [\w-]+ failed/i.test(msg) ||
  /Loading CSS chunk/i.test(msg) ||
  /ChunkLoadError/i.test(msg) ||
  /Importing a module script failed/i.test(msg) ||
  /error loading dynamically imported module/i.test(msg) ||
  // страница появилась в деплое после загрузки вкладки: у старого рантайма нет её чанка
  /couldn't find the correct component chunk/i.test(msg);

if (typeof window !== 'undefined') {
  const reloadOnce = () => {
    if (!window.sessionStorage.getItem('__chunkReloaded')) {
      window.sessionStorage.setItem('__chunkReloaded', '1');
      window.location.reload();
    }
  };
  window.addEventListener('error', (e) => {
    if (isChunkError(e?.message) || (e?.error && e.error.name === 'ChunkLoadError')) reloadOnce();
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e?.reason;
    if (isChunkError(typeof r === 'string' ? r : r?.message) || r?.name === 'ChunkLoadError') reloadOnce();
  });
}

// Деплой при открытом сайте: Gatsby на первом переходе на ещё не открытую страницу
// видит новый webpackCompilationHash в app-data.json и делает window.location = … —
// полная перезагрузка сносит все keep-alive вкладки (мигание + пустые вкладки), а
// деплоев в день десятки. Нам эта защита не нужна: GraphQL-данных у страниц нет,
// старый рантайм грузит только чанки своей сборки, изменённый чанк даёт 404 —
// и Gatsby перезагружает сам (PageResourceStatus.Error), плюс обработчик выше.
// Поэтому каждой странице, загруженной после первого рендера, ставим хеш нашей сборки:
// загрузчик шлёт onPostLoadPageResources до записи в pageDb, payload.page — тот же
// объект, что сравнивает navigation.js, так что и уже открытые вкладки не перезагрузят.
// Проверку первой загрузки (устаревший HTML против свежего JS) не трогаем — она раньше.
export const onInitialClientRender = () => {
  const own = window.___webpackCompilationHash;
  window.___emitter.on('onPostLoadPageResources', ({ page }) => {
    if (page && page.page) page.page.webpackCompilationHash = own;
  });
};

// Сбрасываем флаг при успешной навигации (значит чанки грузятся нормально).
export const onRouteUpdate = () => {
  if (typeof window !== 'undefined') window.sessionStorage.removeItem('__chunkReloaded');
};

// Скроллом полностью управляет система вкладок (useSiteTabs): позиция
// сохраняется и восстанавливается на каждую вкладку отдельно.
export const shouldUpdateScroll = () => false;

// Pages that should NOT have the sidebar layout (e.g. iframe embeds)
const EXCLUDE_LAYOUT = ['/chart', '/chart/'];

export const wrapPageElement = ({ element, props }) => {
  if (EXCLUDE_LAYOUT.includes(props.location.pathname)) {
    return element;
  }
  return <Layout location={props.location}>{element}</Layout>;
};
